import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { MatDialog } from '@angular/material/dialog';
import { InboxDialogComponent } from './inbox.dialog.component';

@Component({
  selector: 'account-lock-component',
  templateUrl: '../sharedTemplates/account-lock.component.html',
})
export class AccountLock implements OnInit, AfterViewInit {
  accountLockData: UntypedFormGroup;
  accountLockDataRaw: any;
  lockDay_disable = false;
  reason: any = [];
  period: any = [];
  selectedPeriod: number;
  constructor(
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    public dialog: MatDialog
  ) {
    this.accountLockData = _FormBuilder.group({
      lockDay: new UntypedFormControl({ value: '', disabled: this.lockDay_disable }, [Validators.required, Validators.min(1)]),
      lock_full: new UntypedFormControl({ value: '', disabled: false }),
      lockReason: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.min(1)]),
    });

    this._ApiService.getProcAccountLockReasonResult().then(x => {
      this.reason = x;
    });

    this._ApiService.getProcAccountLockDayResult().then(x => {
      this.period = x;
    });
  }

  ngOnInit() {
    this.accountLockData.valueChanges.subscribe(x => {
      this.accountLockDataRaw = x;

      if (this.accountLockDataRaw.lock_full) {
        this.lockDay_disable = true;
      } else {
        this.lockDay_disable = false;
      }
    });
    // console.warn(this.accountLockData.controls.lockDay);
  }

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setNavbarTitle('Account_Lock');
  }

  submitAccountLockData() {
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService.accountLock(this.accountLockDataRaw).then(result => {
      if (result.code == '') {
        return 'error|System Error';
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          const t_message = translator.transform(result.message, null);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          this._UiHelper.successSnackBar(result.message, '');
          this.accountLockData.controls.lockDay.disable();
        }
      }
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(InboxDialogComponent, {
      width: '300px',
      data: { data_ActivityCode: 2, data_TicketId: 0, data_Title: '' },
    });
  }

  submitAccountLockDatas() {
    const translator = new TranslatePipe(this._LocalizationService);

    const lockDayValue = this.accountLockData.controls.lockDay.value;
    const LockReasonValue = this.accountLockData.controls.lockReason.value;

    this._ApiService.getProcCustomerAccountLockNewResult(lockDayValue, LockReasonValue).then(result => {
      if (result.resultcode == '') {
        return 'error|System Error';
      } else {
        if (result.resultcode == '') {
          this._UiHelper.errorSnackBar(result.resultmessage, '');
        } else if (result.resultcode == 'errorcode') {
          const t_message = translator.transform(result.resultmessage, null);

          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.resultcode == '117') {
          this._UiHelper.successSnackBar(result.resultmessage, '');
          this.accountLockData.controls.lockDay.disable();
        }
      }

      // if (result.code == "") {
      //   return "error|System Error";
      // } else {
      //   if (result.code == "error") {
      //     this._UiHelper.errorSnackBar(result.message, "");
      //   } else if (result.code == "errorcode") {
      //     let t_message = translator.transform(result.message, null);

      //     this._UiHelper.errorSnackBar(t_message, "");
      //   } else if (result.code == "success") {
      //     this._UiHelper.successSnackBar(result.message, "");
      //     this.accountLockData.controls.lockDay.disable();

      //   }
      // }
    });
  }
}
